import React, {forwardRef} from 'react';

import {withCssModule} from '@pb/kit-util-with-css-module';

import styles from './page.component.module.styl';

import type {ComponentPropsWithRef} from 'react';

type NativeProps = ComponentPropsWithRef<'header'>;

// due to Flow generation issue we need to explicitly define an empty interface here
// eslint-disable-next-line @typescript-eslint/no-empty-object-type
interface PageHeaderProps extends NativeProps {}

const classNames = withCssModule(styles);

/**
 * Top `<header>` bar of a `<Page>` layout.
 *
 * Renders a `<header>` element with the `page__header` layout class. Place
 * `PageLogo`, `PageSearch`, and navigation controls inside as children.
 * Forwards a `ref` to the underlying `<header>` DOM node.
 */
export const PageHeader = forwardRef<HTMLDivElement, PageHeaderProps>((props, ref) => {
    const {className, children, ...headerProps} = props;

    const getClassNames = (): string => {
        return classNames('page__header', className);
    };

    return (
        <header {...headerProps} className={getClassNames()} ref={ref}>
            {children}
        </header>
    );
});

PageHeader.displayName = 'PageHeader';
